import { render, staticRenderFns } from "./LEDPCBNew.vue?vue&type=template&id=4b04c001&scoped=true&"
import script from "./LEDPCBNew.vue?vue&type=script&lang=js&"
export * from "./LEDPCBNew.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCBNew.vue?vue&type=style&index=0&id=4b04c001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04c001",
  null
  
)

export default component.exports